import useProfile from 'hooks/useProfile';
import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom';
import { loadUsetifulScript, setUsetifulTags } from 'usetiful-sdk';

const UseitfulWrapper = ({children}) => {

  const user = useProfile();
  const {pathname} = useLocation();

  useEffect(() => {
    if (user.isLogged) {
      const usetifulKey = window.location.origin === 'https://game.twotwentyk.io' ? '3be0fc97b974e779a9d897877566dd38' : 'a389fcca27e907fb8d5a9f4c685dc59e' ;
      loadUsetifulScript(usetifulKey);
      setUsetifulTags({
        userId: user.auth_id,
        name: user.name,
        email: user.email
      })
      sessionStorage.setItem('user', JSON.stringify(user))
    }
  }, [user])

  useEffect(() => {
    if (user.isLogged && window.USETIFUL) {
      window.USETIFUL.reinitialize();
    }
  }, [pathname])

  return (
    <>
      {children}
    </>
  )
}

export default UseitfulWrapper;
